export enum PromoCodeThemes {
  DEFAULT = 'default',
  DARK = 'dark'
}
